import React from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, Typography } from '@mui/material';

import { LinearLoading } from 'common'

export const FormClient = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormClients } = Forms
    const { formState, onInputChange } = FormClients
    
    const { fetchInfoClient } = FetchData
    const { loadingFetchInfoClient } = fetchInfoClient

    const { onSubmitFormClients, handleClickHideForm } = Actions

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}> 
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idcliente > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchInfoClient && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitFormClients}>
                        <Typography sx={{mt:2,fontWeight: 'bold'}} variant='subtitle2'>
                            Informacion del cliente
                        </Typography>
                        <div className="border-bottom border-dark"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombre"
                                        name="nombre"
                                        value={formState.nombre}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="apellido"
                                        name="apellido"
                                        value={formState.apellido}
                                        onChange={onInputChange}
                                        label='Apellidos'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="apellido_casado"
                                        name="apellido_casado"
                                        value={formState.apellido_casado}
                                        onChange={onInputChange}
                                        label='Apellido de casado'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>

                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="dpi"
                                        name="dpi"
                                        value={formState.dpi}
                                        onChange={onInputChange}
                                        label='DPI/Pasaporte'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="direccion_dpi"
                                        name="direccion_dpi"
                                        value={formState.direccion_dpi}
                                        onChange={onInputChange}
                                        label='Extendido'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nit"
                                        name="nit"
                                        value={formState.nit}
                                        onChange={onInputChange}
                                        label='NIT'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="profesion"
                                        name="profesion"
                                        value={formState.profesion}
                                        onChange={onInputChange}
                                        label='Profesion'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="estado_civil"
                                        name="estado_civil"
                                        value={formState.estado_civil}
                                        onChange={onInputChange}
                                        label='Estado Civil'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nacionalidad"
                                        name="nacionalidad"
                                        value={formState.nacionalidad}
                                        onChange={onInputChange}
                                        label='Nacionalidad'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        
                        <Typography sx={{mt:4,fontWeight: 'bold'}} variant='subtitle2'>
                            Direccion
                        </Typography>
                        <div className="border-bottom border-dark"></div>
                        
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="calle"
                                        name="calle"
                                        value={formState.calle}
                                        onChange={onInputChange}
                                        label='Calle'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="sector"
                                        name="sector"
                                        value={formState.sector}
                                        onChange={onInputChange}
                                        label='Sector'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="lote"
                                        name="lote"
                                        value={formState.lote}
                                        onChange={onInputChange}
                                        label='Numero de casa o lote'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="codigo_ingreso"
                                        name="codigo_ingreso"
                                        value={formState.codigo_ingreso}
                                        onChange={onInputChange}
                                        label='Codigo de ingreso'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="seccion"
                                        name="seccion"
                                        value={formState.seccion}
                                        onChange={onInputChange}
                                        label='Sección'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="manzana"
                                        name="manzana"
                                        value={formState.manzana}
                                        onChange={onInputChange}
                                        label='Manzana'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="zona"
                                        name="zona"
                                        value={formState.zona}
                                        onChange={onInputChange}
                                        label='Zona'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="colonia"
                                        name="colonia"
                                        value={formState.colonia}
                                        onChange={onInputChange}
                                        label='Colonia'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="municipio"
                                        name="municipio"
                                        value={formState.municipio}
                                        onChange={onInputChange}
                                        label='Municipio'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="departamento"
                                        name="departamento"
                                        value={formState.departamento}
                                        onChange={onInputChange}
                                        label='Departamento'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>

                        </Grid>

                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="referencia"
                                        name="referencia"
                                        value={formState.referencia}
                                        onChange={onInputChange}
                                        multiline
                                        rows={3}
                                        label='Referencias'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="direccion_2"
                                        name="direccion_2"
                                        value={formState.direccion_2}
                                        onChange={onInputChange}
                                        multiline
                                        rows={3}
                                        label='Dirección 2'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid> 
                        </Grid>
                        
                        <Typography sx={{mt:4,fontWeight: 'bold'}} variant='subtitle2'>
                            Contacto
                        </Typography>
                        <div className="border-bottom border-dark"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                <FormControl fullWidth>
                                    <TextField
                                        id="celular_1"
                                        name="celular_1"
                                        value={formState.celular_1}
                                        onChange={onInputChange}
                                        label='Celular 1'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                <FormControl fullWidth>
                                    <TextField
                                        id="celular_2"
                                        name="celular_2"
                                        value={formState.celular_2}
                                        onChange={onInputChange}
                                        label='Celular 2'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                <FormControl fullWidth>
                                    <TextField
                                        id="telefono_casa"
                                        name="telefono_casa"
                                        value={formState.telefono_casa}
                                        onChange={onInputChange}
                                        label='Telefono Casa'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                <FormControl fullWidth>
                                    <TextField
                                        id="telefono_trabajo"
                                        name="telefono_trabajo"
                                        value={formState.telefono_trabajo}
                                        onChange={onInputChange}
                                        label='Telefono Trabajo'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                <FormControl fullWidth>
                                    <TextField
                                        id="extension"
                                        name="extension"
                                        value={formState.extension}
                                        onChange={onInputChange}
                                        label='Extension'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} >
                                <FormControl fullWidth>
                                    <TextField
                                        id="correo"
                                        name="correo"
                                        value={formState.correo}
                                        onChange={onInputChange}
                                        label='Correo Electronico'
                                        size='small'
                                        type="email"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        
                        <Typography sx={{mt:4,fontWeight: 'bold'}} variant='subtitle2'>
                            Referencias
                        </Typography>
                        <div className="border-bottom border-dark"></div>
                        
                        <Typography sx={{mt:4}} variant='subtitle2'>
                            Familiares
                        </Typography>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombres_familiar_1"
                                        name="nombres_familiar_1"
                                        value={formState.nombres_familiar_1}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="parentesco_familiar_1"
                                        name="parentesco_familiar_1"
                                        value={formState.parentesco_familiar_1}
                                        onChange={onInputChange}
                                        label='Parentesco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="contacto_familiar_1"
                                        name="contacto_familiar_1"
                                        value={formState.contacto_familiar_1}
                                        onChange={onInputChange}
                                        label='Contacto'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombres_familiar_2"
                                        name="nombres_familiar_2"
                                        value={formState.nombres_familiar_2}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="parentesco_familiar_2"
                                        name="parentesco_familiar_2"
                                        value={formState.parentesco_familiar_2}
                                        onChange={onInputChange}
                                        label='Parentesco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="contacto_familiar_2"
                                        name="contacto_familiar_2"
                                        value={formState.contacto_familiar_2}
                                        onChange={onInputChange}
                                        label='Contacto'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombres_familiar_3"
                                        name="nombres_familiar_3"
                                        value={formState.nombres_familiar_3}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="parentesco_familiar_3"
                                        name="parentesco_familiar_3"
                                        value={formState.parentesco_familiar_3}
                                        onChange={onInputChange}
                                        label='Parentesco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="contacto_familiar_3"
                                        name="contacto_familiar_3"
                                        value={formState.contacto_familiar_3}
                                        onChange={onInputChange}
                                        label='Contacto'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Typography sx={{mt:4}} variant='subtitle2'>
                            Personales
                        </Typography>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombres_personal_1"
                                        name="nombres_personal_1"
                                        value={formState.nombres_personal_1}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="parentesco_personal_1"
                                        name="parentesco_personal_1"
                                        value={formState.parentesco_personal_1}
                                        onChange={onInputChange}
                                        label='Parentesco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="contacto_personal_1"
                                        name="contacto_personal_1"
                                        value={formState.contacto_personal_1}
                                        onChange={onInputChange}
                                        label='Contacto'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombres_personal_2"
                                        name="nombres_personal_2"
                                        value={formState.nombres_personal_2}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="parentesco_personal_2"
                                        name="parentesco_personal_2"
                                        value={formState.parentesco_personal_2}
                                        onChange={onInputChange}
                                        label='Parentesco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="contacto_personal_2"
                                        name="contacto_personal_2"
                                        value={formState.contacto_personal_2}
                                        onChange={onInputChange}
                                        label='Contacto'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:2}}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombres_personal_3"
                                        name="nombres_personal_3"
                                        value={formState.nombres_personal_3}
                                        onChange={onInputChange}
                                        label='Nombres'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="parentesco_personal_3"
                                        name="parentesco_personal_3"
                                        value={formState.parentesco_personal_3}
                                        onChange={onInputChange}
                                        label='Parentesco'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="contacto_personal_3"
                                        name="contacto_personal_3"
                                        value={formState.contacto_personal_3}
                                        onChange={onInputChange}
                                        label='Contacto'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        
                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#47c4c7", borderRadius: '5px'}}
                                        // color='primary'
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{background: "#ef8157", borderRadius: '5px'}}
                                        // color='primary'
                                        variant="contained"
                                        type='button'
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
